import React, { useEffect } from "react";
import { ValentineHearts } from "./ValentineHearts";
import { useHolidayTheme } from "@/hooks/useHolidayTheme";
import "@/styles/seasonal.css";

export const ValentineThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isValentine } = useHolidayTheme();

  useEffect(() => {
    if (isValentine) {
      document.body.classList.add("valentine-theme");
      document.documentElement.style.setProperty("--seasonal-accent", "330 80% 60%");
      document.documentElement.style.setProperty("--seasonal-glow", "330 80% 60% / 0.3");
    } else {
      document.body.classList.remove("valentine-theme");
      document.documentElement.style.removeProperty("--seasonal-accent");
      document.documentElement.style.removeProperty("--seasonal-glow");
    }

    return () => {
      document.body.classList.remove("valentine-theme");
      document.documentElement.style.removeProperty("--seasonal-accent");
      document.documentElement.style.removeProperty("--seasonal-glow");
    };
  }, [isValentine]);

  return (
    <>
      {isValentine && <ValentineHearts count={28} />}
      {children}
    </>
  );
};

export default ValentineThemeProvider;
